export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=yes, viewport-fit=cover"},{"name":"naver-site-verification","content":"36adf1fa0f62537573b4d277efe3c9f4ae0b9b05"},{"name":"google-site-verification","content":"QYcEpdgEUKjhWtFGFuFKGza6JTqdYmwJUPLFy2etQg0"}],"link":[{"rel":"preload","href":"/fonts/mwsDefaultFontRegular.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preload","href":"/fonts/mwsDefaultFontSemiBold.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preload","href":"/fonts/mwsDefaultFontBold.woff2","as":"font","type":"font/woff2","crossorigin":""},{"rel":"preload","href":"/fonts/mwsDefaultFontBlack.woff2","as":"font","type":"font/woff2","crossorigin":""}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"prefetchOn":{"interaction":true,"visibility":false},"componentName":"NuxtLink","prefetch":true}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false